import React, { Fragment } from 'react';
import { Container, Button } from 'react-bootstrap';
import Header from '../../components/header_ouvid';
import Head from '../../components/head';
import Footer from '../../components/footer';
import Video from '../../assets/tutoriais/CONSULTAR-REQUISICAO.mp4'
import '../../styles/header.scss';

function OuvidoriaScreen() {
    return (
        <Fragment>
            <Head titulo="Como acompanhar um pedido de informação - E-SIC" />
            <Header />
            <Container>
            <video className='video-esic' width="80%" height="500" controls>
                    <source src={Video} type="video/mp4" />
                    Seu navegador não suporta a reprodução de vídeo.
    </video>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default OuvidoriaScreen;